export const authTitleClassName = "text-[28px] font-bold tracking-tight text-foreground lg:text-[30px]";

export const authSubtitleClassName = "mt-2 text-[15px] leading-relaxed text-foreground-muted";

export const authLabelClassName = "text-sm font-bold text-foreground";

export const authFormClassName = "space-y-3";

export const authHeaderClassName = "mb-5";

export const authFieldClassName = "space-y-1";

export const authValidationAreaClassName = "h-5";

export const authSecondaryActionContainerClassName = "flex justify-center";

export const authSecondaryActionClassName = "inline-flex min-h-11 items-center justify-center gap-2 px-2 text-sm font-medium text-brand-dark underline-offset-4 hover:underline focus:outline-none focus:ring-2 focus:ring-focus/30";

export type AuthInputState = "default" | "invalid";

export const authInputClassName = (state: AuthInputState | boolean, padding = "pl-11 pr-10") => {
  const resolvedState: AuthInputState = typeof state === "boolean" ? (state ? "invalid" : "default") : state;
  const stateClassName = {
    default: "border-border-strong hover:border-slate-400",
    invalid: "border-red-500 hover:border-red-500",
  }[resolvedState];

  return `min-h-12 w-full rounded-xl border bg-surface py-2 ${padding} text-[15px] text-foreground outline-none transition-colors placeholder:text-slate-400 focus:border-focus focus:ring-4 focus:ring-brand/10 disabled:cursor-not-allowed disabled:border-border disabled:bg-slate-100 disabled:text-slate-500 ${stateClassName}`;
};

export const authPrimaryButtonClassName = (disabled: boolean) =>
  `min-h-12 w-full rounded-xl px-4 py-3 text-[15px] font-bold transition-colors focus:outline-none focus:ring-2 focus:ring-focus/30 ${
    disabled
      ? "cursor-not-allowed bg-slate-200 text-slate-500"
      : "bg-brand text-white shadow-card hover:bg-brand-dark"
  }`;
